import { useRecoilState, useSetRecoilState } from 'recoil';
import * as AppState from '../AppState';
import { elasticBoundsValid, getBoundsOfCurrentMapForElasticSearch } from '../components/Map/MapUtilities';
import { AreaType, LocationOrigin, UserLocation } from '../interfaces/interfaces';

/**
 * Custom React Hook - Puts Elastic Search results into recoil state
 *   - Get Geocode data from Google Places API
 *   - Get Elastic Search results of properties
 * @param autoCompleteSelection  (result when user clicks a selection in the location autocomplete dropdown)
 * @returns boolean of success --> array of properties from Elastic Search Server goes into Recoil State
 */
export function useSetLocation() {

	const [gsUserLocation, setGsUserLocation] = useRecoilState(AppState.gsUserLocation);
	const setGsUserSearchLocation = useSetRecoilState(AppState.gsUserSearchLocation);
	const setGsUserSearch = useSetRecoilState(AppState.gsUserSearch);

	function setLocationOnMapChange(changeEvent: any, userSearchLocation: UserLocation | null) {

		const { bounds } = changeEvent;
		if (bounds) {
			const boundsForElastic = getBoundsOfCurrentMapForElasticSearch(bounds);
			if (elasticBoundsValid(boundsForElastic)) {
				/*
					If userSearchExists, reset the userSearchLocation, and set gsUserLocation to proper search
				*/
				if (userSearchLocation && (userSearchLocation.origin === LocationOrigin.UserSearch || userSearchLocation.origin === LocationOrigin.CurrentLocation || userSearchLocation.origin === LocationOrigin.UrlState)) {
					//console.log('%c On Map Change Location, changeevent: ', 'background: blue; color: white', userSearchLocation, changeEvent, gsUserLocation)
					setGsUserSearch({});
					setGsUserSearchLocation(null);
					setGsUserLocation({
						...userSearchLocation,
						centerMap: changeEvent.center,
						zoomLevel: changeEvent.zoom,
						boundsElastic: boundsForElastic,
					});
				}
				/*
					else, since userSearchLocation is null, call must be from mapBounds, so set location to be from map bounds
				*/
				else if (userSearchLocation === null && gsUserLocation.initialized) {
					//console.log('%c On Map Change Location, changeevent: ', 'background: lightblue; color: white', userSearchLocation, changeEvent, gsUserLocation)
					setGsUserLocation({
						initialized: true,
						areaType: AreaType.Geopoint,
						centerMap: changeEvent.center,
						zoomLevel: changeEvent.zoom,
						boundsElastic: boundsForElastic,
						origin: LocationOrigin.MapBounds
					});
				}
			}
		}
	}

	return setLocationOnMapChange;
}
